"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _SearchV = _interopRequireDefault(require("@insided/destination/icons/SearchV2"));

var _LoadingSpinnerV = _interopRequireDefault(require("@insided/destination/icons/LoadingSpinnerV2"));

var _CancelV = _interopRequireDefault(require("@insided/destination/icons/CancelV2"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var handleEnter = function handleEnter(e, onEnter) {
  if (e.key === 'Enter' && onEnter) {
    e.preventDefault();
    e.stopPropagation();
    onEnter();
  }
};

var handleChange = function handleChange(e, onChange) {
  if (e.target instanceof HTMLInputElement && onChange) {
    onChange(e.target.value);
  }
};

var InputGroup = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(InputGroup, _PureComponent);

  var _super = _createSuper(InputGroup);

  function InputGroup() {
    var _this;

    (0, _classCallCheck2.default)(this, InputGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "input", (0, _preact.createRef)());
    return _this;
  }

  (0, _createClass2.default)(InputGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // console.log('%c InputGroup mounted', 'color: yellow; background-color: black; font-size: 16px;')
      if (this.props.initialValue && !!this.input.current) {
        // eslint fix for: Forbidden non-null assertion
        this.input.current.value = this.props.initialValue;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$input$current,
          _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          onEnter = _this$props.onEnter,
          onFocus = _this$props.onFocus,
          onBlur = _this$props.onBlur,
          onChange = _this$props.onChange,
          disabled = _this$props.disabled,
          loading = _this$props.loading;
      return (0, _preact.h)("div", {
        className: "form-group"
      }, (0, _preact.h)("div", {
        className: "input-wrapper"
      }, (0, _preact.h)("span", {
        className: "pre-icon-wrapper input-icon-wrapper"
      }, loading ? (0, _preact.h)(_LoadingSpinnerV.default, {
        width: 20,
        height: 20,
        fill: "#6B707E",
        className: "instant-search-loader small-loader"
      }) : (0, _preact.h)(_SearchV.default, {
        width: 24,
        height: 24
      })), (0, _preact.h)("input", (0, _extends2.default)({
        ref: this.input,
        autoFocus: true,
        className: "input-group ".concat(className, " has-post-icon"),
        onKeyUp: function onKeyUp(e) {
          return handleChange(e, function (value) {
            onChange(value);
          });
        },
        onKeyDown: function onKeyDown(e) {
          return handleEnter(e, onEnter);
        },
        onFocus: onFocus,
        onBlur: onBlur,
        disabled: disabled
      }, this.props.attributes)), !loading && ((_this$input$current = this.input.current) === null || _this$input$current === void 0 ? void 0 : _this$input$current.value) && (0, _preact.h)(_phrase.default, {
        p: "accessibility_label.clear_search",
        renderAsText: true
      }, function (clearSearchLabel) {
        return (0, _preact.h)("span", {
          role: "button",
          tabIndex: 0,
          className: "post-icon-wrapper input-icon-wrapper",
          "aria-label": clearSearchLabel,
          onClick: function onClick() {
            var _this2$input$current;

            _this2.props.onChange('');

            if ((_this2$input$current = _this2.input.current) !== null && _this2$input$current !== void 0 && _this2$input$current.value) {
              _this2.input.current.value = '';
            }
          }
        }, (0, _preact.h)(_CancelV.default, {
          width: 18,
          height: 18,
          fill: "#6B707E"
        }));
      })));
    }
  }]);
  return InputGroup;
}(_preactCompat.PureComponent);

var _default = InputGroup;
exports.default = _default;